import { useMemo } from 'react'

export default function useCategorySort(categories) {
  const sortedCategories = useMemo(() => {
    if (!categories || !categories.length) return []
    const hasCreatedAt = categories.some((item) => item.createdAt)
    const hasNumericId = categories.some(
      (item) => typeof item.id === 'number' || (!isNaN(Number(item.id)) && item.id !== '')
    )

    if (hasCreatedAt) {
      return [...categories].sort(
        (a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0)
      )
    }
    if (hasNumericId) {
      return [...categories].sort((a, b) => (Number(b.id) || 0) - (Number(a.id) || 0))
    }
    return [...categories].reverse()
  }, [categories])

  return sortedCategories
}
